import { withInstall } from '@ll-plus/utils'

import Descriptions from './src/descriptions.vue'

export const LlDescriptions = withInstall(Descriptions)
export default LlDescriptions
export * from './src/descriptions'

declare module 'vue' {
  export interface GlobalComponents {
    LlDescriptions: typeof Descriptions
  }
}
